module.exports = __webpack_public_path__ + "img/GreekTechHopliteS_ua.486a2ba0.webp";